import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import NotificationsService from "../services/NotificationsService";

const POLLING_MS = 30000;

export const notifKeys = {
  all: ["notifications"],
  list: (page) => ["notifications", "list", page],
  unread: ["notifications", "unread-count"],
};

const useToken = () => useSelector((state) => state.auth.token);

export function useUnreadCount() {
  const token = useToken();
  return useQuery({
    queryKey: notifKeys.unread,
    queryFn: () => NotificationsService.unreadCount(token).then((r) => r.data.data.total),
    enabled: !!token,
    refetchInterval: POLLING_MS, // en pause automatiquement quand l'onglet est caché
  });
}

export function useNotifications(page = 1) {
  const token = useToken();
  return useQuery({
    queryKey: notifKeys.list(page),
    queryFn: () => NotificationsService.index(page, token).then((r) => r.data.data),
    enabled: !!token,
  });
}

export function useMarkAsRead() {
  const token = useToken();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => NotificationsService.markAsRead(id, token),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: notifKeys.all }),
  });
}

export function useMarkAllAsRead() {
  const token = useToken();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => NotificationsService.markAllAsRead(token),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: notifKeys.all }),
  });
}